import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {PostAPICommand} from '@drl/core/api/commands/post-api.command';
import {environment} from '@drl/env/environment';

export class OtpVerificationCommand<T> extends PostAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.authApiUrl}/auth/verify-otp`);
  }
}

export class ResendOtpCommand<T> extends PostAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.authApiUrl}/auth/resend-otp`);
  }
}
